import { render } from "./InventoryItemDialog.vue?vue&type=template&id=1c26b5ea"
import script from "./InventoryItemDialog.vue?vue&type=script&lang=js"
export * from "./InventoryItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__